export default __webpack_public_path__ + "static/media/about-footer-phone.71b3d5c5.svg";